const isUUID = (value: string) => {
  // Regular expression to check if string is a valid UUID
  const regexExp = /^[\da-f]{8}(?:\b-[\da-f]{4}){3}\b-[\da-f]{12}$/gi;

  return regexExp.test(value);
};

export default isUUID;
